import { useMutation } from '@apollo/client';

import UPDATE__BASIC_USER_INFO from './graphql/UpdateBasicUserInfoMutation.graphql';
import {
  UpdateBasicUserInfo,
  UpdateBasicUserInfoVariables,
} from './graphql/types/UpdateBasicUserInfo';

export const useUpdateBasicUserInfo = () => {
  const [updateBasicUserInfo] = useMutation<
    UpdateBasicUserInfo,
    UpdateBasicUserInfoVariables
  >(UPDATE__BASIC_USER_INFO);

  const updateUserInfo = (userData: UpdateBasicUserInfoVariables) => {
    return updateBasicUserInfo({
      variables: userData,
    });
  };

  return { updateUserInfo };
};
